exports = module.exports = require("../../../target/scala-2.13/scalajs-bundler/main/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  font-family: sans-serif;\n}\n", ""]);

